import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { UsersRepositoryToken } from '../../di/tokens';

export function useUsers(email?: string, page = 1, perPage = 10) {
  const repository = container.resolve(UsersRepositoryToken);
  return useQuery({
    queryKey: ['users', email, page, perPage],
    queryFn: () => repository.list({ email, page, perPage }),
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  });
}
